/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

interface Props {
  condition: boolean;
  children: React.ReactElement | React.ReactElement[];
  wrapper: (children: React.ReactElement | React.ReactElement[]) => JSX.Element;
}

export function ConditionalWrapper({ condition, wrapper, children }: Props) {
  return condition ? wrapper(children) : <>{children}</>;
}
